<template>
    <div v-cloak>
        <div class="loader" v-if="!loaded"><i class="fas fa-circle-notch fa-spin"></i></div>
        <div class="blogWrapper blogPage" v-if="loaded">
            <div class="postFilter">
                <div class="filterIntro">
                    <h3>{{ header_title }}</h3>
                    <div v-if="header_description != ''" v-html="header_description" class="filterDescription"></div>
                </div>
                <div class="inputFlex">
                    <div class="inputWrap" v-if="post_filter.filter && categories_array">
                        <label>By Category</label>
                        <v-select :options="categories_array"
                                  id="categories"
                                  v-model="category"
                                  key="categories"
                                  placeholder="All Categories"
                                  :searchable="false"
                                  :reduce="category => category.term_id"
                                  label="cat_name"
                        ></v-select>
                    </div> <!-- .inputWrap -->

                    <div class="inputWrap" v-if="post_filter.filter.months">
                        <label>Dates</label>
                        <v-select :options="post_filter.filter.months"
                                  id="months"
                                  v-model="months"
                                  key="months"
                                  placeholder="Dates"
                        ></v-select>
                    </div> <!-- .inputWrap -->

                </div>
            </div> <!-- .postFilter -->

            <div class="blogPostsWrap" :class="(reloading) ? 'reloading':''">
                <div v-if="post_filter.posts.length > 0">
                    <posts :posts="post_filter.posts"></posts>

                    <paginate
                        v-if="post_filter.pagination.total_pages > 1"
                        :page-count="post_filter.pagination.total_pages"
                        :page-range="7"
                        :margin-pages="1"
                        :click-handler="switchPage"
                        :prev-text="'<i class=\'far fa-angle-left\'></i>'"
                        :next-text="'<i class=\'far fa-angle-right\'></i>'"
                        :container-class="'pagination'"
                        :page-class="'page-numbers'"
                        :hide-prev-next="true"
                    ></paginate>
                </div>

                <div v-else class="emptyState">
                    <div class="wrapper">
                        <div class="emptyStateMessage alert">
                            No results found.
                        </div>
                    </div>
                </div> <!-- .emptyState -->
            </div> <!-- .blogPostsWrap -->
        </div> <!-- .blogWrapper -->
    </div> <!-- v-cloak -->
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
    props: {
        'title': '',
        'description': '',
        'categories': []
    },
    data() {
        return {
            category: null,
            categories_array: [],
            months: null,
            header_title: this.title,
            header_description: this.description,
            page: 1,
            loaded: false,
            reloading: false,
            post_filter: [],
        };
    },
    components: {
        Paginate
    },
    mounted() {
        this.update()
    },
    methods: {
        output(thing) {
          console.log(thing);
        },
        switchPage(page) {
            const el = this.$el.getElementsByClassName('blogWrapper')[0]

            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
            }

            this.page = page
        },
        update() {
            let form_data = new FormData();
            this.reloading = true
            let categories_json = jQuery.parseJSON(this.categories);
            let categories_array = [];

            $.each(categories_json,function(key,value){
                if(key > 0 && value != ""){
                    categories_array.push({
                        term_id : key,
                        cat_name : value
                    });
                }
            });

            this.categories_array = categories_array;

            // Set up form ajax catch
            form_data.append('action', 'post_filter')
            form_data.append('method', 'fetch_posts')

            form_data.append('category', this.category)
            form_data.append('months', this.months ? this.months.code : null)
            form_data.append('page', this.page)

            fetch('/wp-admin/admin-ajax.php', {
                method: "post",
                headers: new Headers({
                    'Accept': 'application/json'
                }),
                credentials: 'same-origin',
                body: form_data,
            }).then((data) => data.json())
                .then((response) => {
                    this.loaded = true
                    this.reloading = false
                    this.post_filter = response
                })
        },
    },
    watch: {
        category() {
            this.page = 1
            this.update()
        },
        months: function () {
            this.page = 1;
            this.update();
        },
        page() {
            this.update()
        }
    }
}
</script>
